import { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const params = useParams();
  
  // Refs para rastrear valores anteriores
  const prevPathnameRef = useRef(pathname);
  const prevSearchRef = useRef(search);
  const prevParamsRef = useRef(params);

  useEffect(() => {
    // Extrair parâmetros relevantes
    const currentLessonId = params.lessonId;
    const currentModuleSlug = params.moduleSlug;
    const currentCourseSlug = params.courseSlug;
    
    const prevLessonId = prevParamsRef.current.lessonId;
    const prevModuleSlug = prevParamsRef.current.moduleSlug;
    const prevCourseSlug = prevParamsRef.current.courseSlug;
    
    // Detectar mudanças relevantes
    const pathnameChanged = prevPathnameRef.current !== pathname;
    const searchChanged = prevSearchRef.current !== search;
    const lessonIdChanged = currentLessonId !== prevLessonId;
    const moduleSlugChanged = currentModuleSlug !== prevModuleSlug;
    const courseSlugChanged = currentCourseSlug !== prevCourseSlug;
    
    // Verificar se é uma página de lesson, module ou course
    const isLessonPage = pathname.includes('/lesson/') || 
                         pathname.includes('/student-lesson-page') ||
                         currentLessonId;
    const isModulePage = pathname.includes('/module/') || 
                         pathname.includes('/modules') ||
                         currentModuleSlug;
    const isCoursePage = pathname.includes('/course/') || 
                         pathname === '/courses';
    
    // Fazer scroll se houver mudança relevante em páginas de lesson, module ou course
    const shouldScroll = (pathnameChanged || searchChanged || 
                         lessonIdChanged || moduleSlugChanged || courseSlugChanged) &&
                         (isLessonPage || isModulePage || isCoursePage);
    
    if (shouldScroll) {
      // Usar requestAnimationFrame para garantir que o scroll aconteça após o DOM atualizar
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
      });
    }
    
    // Atualizar refs
    prevPathnameRef.current = pathname;
    prevSearchRef.current = search;
    prevParamsRef.current = params;
  }, [pathname, search, params]);

  return null;
};

export default ScrollToTop;